import { fetchCaptchaData } from '@eliadmin/core/src/api/recaptcha-fetcher';
import { CaptchaAction } from '@eliadmin/core/src/api/recaptcha-actions';
import type { GenericRequest } from '@eliadmin/core/src/api/api-types';
import { fetchData } from '@eliadmin/core/src/api/fetcher';
import type { AskAboutProductFormValues } from '@eliadmin/core/src/components/product/detail/product-ask-dialog';

export type ContactMessageReq = GenericRequest<{
  data: {
    subject?: string;
    email?: string;
    text?: string;
    order_number?: string;
    name?: string;
    surname?: string;
    phone?: string;
    attachments?: { id: number }[];
    custom?: Record<string, any>;
    gdpr: boolean;
    newsletter?: boolean;
    newsletter_return_url?: string;
    'g-recaptcha-response'?: string;
  };
}>;
export function sendContactMessage(req: ContactMessageReq) {
  return fetchCaptchaData({
    method: 'POST',
    uri: '/store/forms/contact',
    body: req.data,
    locale: req.locale,
  }, CaptchaAction.CONTACT);
}

// Added: wholesaler-contact endpoint not present in upstream package
export function sendWholesalerContactMessage(req: ContactMessageReq) {
  return fetchCaptchaData({
    method: 'POST',
    uri: '/store/forms/wholesaler-contact',
    body: req.data,
    locale: req.locale,
  }, CaptchaAction.WHOLESALER_CONTACT);
}

export type AskAboutProductReq = GenericRequest<{
  data: AskAboutProductFormValues;
}>;

export function askAboutProduct(req: AskAboutProductReq) {
  return fetchCaptchaData({
    method: 'POST',
    uri: '/store/forms/product',
    body: req.data,
    locale: req.locale,
  }, CaptchaAction.ASK_QUESTION);
}

export type AskSupplierAboutProductReq = GenericRequest<{
  data: {
    place_of_delivery: {
      id?: number | string;
    };
    product: {
      id: number;
    };
    product_url: string;
    quantity: number | string;
    email: string;
    phone?: string;
    gdpr: boolean;
    'g-recaptcha-response'?: string;
  };
}>;

export function askSupplierAboutProduct(req: AskSupplierAboutProductReq) {
  return fetchCaptchaData({
    method: 'POST',
    uri: '/store/forms/delivery-place-product',
    body: req.data,
    locale: req.locale,
  }, CaptchaAction.ABOUT_PRODUCT_SUPPLIER);
}

export type SendPriceOfferMessageReq = GenericRequest<{
  data: {
    name: string;
    surname: string;
    email: string;
    phone: string;
    text: string;
    place_of_execution: string;
    interested_in: string;
    near_a_stream: string;
    sloping_plot: string;
    place_treat_wastewater?: string;
    gdpr: boolean;
    people_count: number;
    'g-recaptcha-response'?: string;
  };
}>;

export function sendPriceOfferMessage(req: SendPriceOfferMessageReq) {
  return fetchData({
    method: 'POST',
    uri: '/store/forms/price-offer',
    body: req.data,
    locale: req.locale,
  });
}

export type ServiceMessageReq = GenericRequest<{
  data: {
    name: string;
    service_address: string;
    phone: string;
    contract_number: string;
    reason: string;
    note?: string;
    post_warranty: boolean;
    gdpr: boolean;
    'g-recaptcha-response': string;
  };
}>;

export function sendServiceMessage(req: ServiceMessageReq) {
  return fetchData({
    method: 'POST',
    uri: '/store/forms/service',
    body: req.data,
    locale: req.locale,
  });
}

export type GrantMessageReq = GenericRequest<{
  data: {
    interested_in: string;
    name: string;
    city: string;
    email?: string;
    phone: string;
    note?: string;
    attachments?: { id: number }[];
    gdpr: boolean;
    'g-recaptcha-response': string;
  };
}>;

export function sendGrantMessage(req: GrantMessageReq) {
  return fetchData({
    method: 'POST',
    uri: '/store/forms/grant',
    body: req.data,
    locale: req.locale,
  });
}
